import { FlexColumn, FlexRowCenter } from "designSystem/index";
import React, { FunctionComponent } from "react";
import TableChartOptions from "./TableChartOptions";
import TablePrintOptions from "./TablePrintOptions";
import TableViewOptions from "./TableViewOptions";

const TableOptionsTab: FunctionComponent = function TableOptionsTab() {
	return (
		<FlexRowCenter data-csi-automation="TableOptionsTab">
			<FlexColumn width="100%">
				<TableViewOptions />
				<TableChartOptions />
				<TablePrintOptions />
			</FlexColumn>
		</FlexRowCenter>
	);
};

export = TableOptionsTab;